'use strict'

/**
 * Vues erreur HTTP (404 / 500)
 */

import master from 'Modules/master'

master.process()
